function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStickUpArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: "25px",
    width: "20px",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Artboard-4") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Up-4",
    "data-name": "Up"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.707,9.707a1,1,0,0,1-1.414,0L13,8.414V18a1,1,0,0,1-2,0V8.414L9.707,9.707A1,1,0,0,1,8.293,8.293l3-3a1,1,0,0,1,1.416,0l3,3A1,1,0,0,1,15.707,9.707Z",
    style: {
      fill: "#1c1b1e"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStickUpArrow);
export default __webpack_public_path__ + "static/media/stickUpArrow.058215805e9468ec7e49e5991addb637.svg";
export { ForwardRef as ReactComponent };